const messages = {
  pageTitle: 'User Profile',
  sections: {
    personalInfo: 'Personal Information',
  },
  fields: {
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
  },
  validation: {
    emailRequired: 'Email is required',
  },
  actions: {
    save: 'Save',
    resetPassword: 'Reset Password',
  },
  password: {
    title: 'Password Reset',
    show: 'Show password',
    hide: 'Hide password',
    fields: {
      current: 'Old Password',
      new: 'New Password',
      confirm: 'Confirm New Password',
    },
    errors: {
      currentRequired: 'Old Password is required',
      newRequired: 'This field is required',
      confirmRequired: 'This field is required',
      minLength: 'Password must be at least %{min} characters',
      pattern:
        'Password must have at least one capital letter, one small letter, one numeric digit and one special character.',
      mismatch: 'Passwords do not match',
    },
  },
  notifications: {
    profileUpdated: 'User details updated successfully',
    passwordUpdated: 'Password updated successfully',
    loadFailed: 'Failed to load profile',
    saveFailed: 'Failed to save profile',
    passwordFailed: 'Failed to update password',
  },
};

export default messages;
